import i18next from 'app/lib/i18n/i18n';
import { useTranslation } from 'react-i18next';
import { TPaths } from 'app/lib/@types';
import en from './en.json';
import ru from './ru.json';

const roleMatrixTranslationNs = 'roleMatrix';

i18next.addResourceBundle('en', roleMatrixTranslationNs, en);
i18next.addResourceBundle('ru', roleMatrixTranslationNs, ru);

declare module 'i18next' {
  interface i18nResources {
    [roleMatrixTranslationNs]: typeof en;
  }
  interface CustomTypeOptions {
    // custom namespace type if you changed it
    //defaultNS: typeof companiesPanelTranslationNs;
    // custom resources type
    resources: i18nResources;
  }
}

export type TRolemMatrixTranslationPaths = TPaths<typeof en> &
  TPaths<typeof ru>;

export function useRoleMatrixTranslations(): (
  key: TRolemMatrixTranslationPaths,
  options?: Record<string, string | number>
) => string {
  const { t } = useTranslation(roleMatrixTranslationNs);
  return t;
}
